import { render, staticRenderFns } from "./CreateShipmentPreview.vue?vue&type=template&id=4750666f&scoped=true&"
import script from "./CreateShipmentPreview.vue?vue&type=script&lang=js&"
export * from "./CreateShipmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./CreateShipmentPreview.vue?vue&type=style&index=0&id=4750666f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4750666f",
  null
  
)

export default component.exports